import { DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonHttpService } from 'src/app/common.service';
import { ConfigurationService } from 'src/app/configuration.service';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { ClientHttpService } from '../client-parent.service';
import { DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { ClientDocumentFormBO, GetClientDocumentBO } from '../client-parent.model';
import { IMyDpOptions } from 'mydatepicker';
import { takeUntil } from 'rxjs/operators';
import { document } from 'ngx-bootstrap/utils';
import { DocumentListService } from './client-documentdataservice';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-client-document',
  templateUrl: './client-document.component.html',
  styleUrls: ['./client-document.component.scss']

})
export class ClientDocumentComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent
  public DocumentList: Observable<DataStateChangeEventArgs>;
  ClientDocumentFilterBO: GetClientDocumentBO = new GetClientDocumentBO();
  ClientDocumentForm: ClientDocumentFormBO;
  arraycol: any = [];
  pageSizes: any = [];
  today: Date = new Date();
  filterOptions = { type: 'Menu' };
  initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  public formatOptions = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };
  onDestroy$: Subject<void> = new Subject<void>();
  DocumentId: string;
  DocumentUrl: SafeResourceUrl;
  DocumentName: string;
  isPdf: boolean = true;
  pdfUrl: SafeResourceUrl | string = null;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };
  constructor(
    private cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    public dateservice: DateService,
    public configurationservice: ConfigurationService,
    public http: HttpClientModule,
    public ClientService: ClientHttpService,
    public toasterService: ToastrService,
    public global: GlobalComponent,
    public DocumentListService: DocumentListService,
    private sanitizer: DomSanitizer) {
    this.DocumentList = DocumentListService;
  }
  ngOnInit(): void {
    this.ClientDocumentForm = new ClientDocumentFormBO();
    this.ClientDocumentFilterBO.clientID = this.global.clientId;
    console.log(this.global.clientId, this.global.globalHeadAgencyId)
    this.loadClientDocuments();
  }
  //////////////////////////////////////Save New Document////////////////////////////////////
  saveDocument() {
    let body = new FormData();
    body.append('DocumentName', this.ClientDocumentForm.documentName);
    body.append('DocumentTitle', this.ClientDocumentForm.documentTitle);
    body.append('AttachedDate', this.today.toUTCString());
    body.append('ClientId', this.global.clientId);
    body.append('FileAt', this.ClientDocumentForm.fileAt);
    console.log(body);
    this.ClientService.uploadClientDocument(body).subscribe(
      (data) => {
        this.toasterService.success("Document Saved Successfully");
        document.getElementById('DocumentModalopen').click();
        this.loadClientDocuments();
      },
      (err) => {
        this.toasterService.error(err);
        console.log(err);
        document.getElementById('DocumentModalopen').click();
      }
    );
  }
  ///////////////////////////////////Delete Document/////////////////////////////////////////////////
  setDocumentId(data) {
    this.DocumentId = data.id;
  }
  Delete() {
    let params = new URLSearchParams();
    params.append('Id', this.DocumentId);
    this.ClientService.deleteClientDocument(params).subscribe(
      (data) => {
        this.toasterService.success("Document deleted!");
        document.getElementById('openClientDocument').click();
        this.loadClientDocuments();
      },
      (err) => {
        this.toasterService.error(err);
        document.getElementById('openClientDocument').click();
      }
    );
  }
  //////////////////////////////////Download Document///////////////////////////
  DownloadDocument(data) {
    let params = new URLSearchParams();
    params.append('Id', data.id);
    this.ClientService.downloadClientDocument(params).pipe(takeUntil(this.onDestroy$)).subscribe(
      (response) => {
        this.toasterService.success("Document Downloaded Sucessfully");
        console.log(data.documentName, data);
        this.startDownload(response, data.documentName);

      },
      (err) => {
        // console.log(err)
        this.toasterService.error(err);
      }
    );
  }
  startDownload(url: string, fileName: string) {
    try {
      var link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
    }catch(err){
      // console.log(err)
      this.toasterService.error(err);
    }
  }
  /////////////////////////////////////////////////////Attach File///////////////////////////////////////////
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.ClientDocumentForm.fileAt = file;
      this.ClientDocumentForm.documentName = file.name;
    }
  }
  reset(){
    document.getElementById("ClientDocumentFormFile").value = null;
    this.ClientDocumentForm = new ClientDocumentFormBO();
    this.cdr.detectChanges();
  }
  //////////////////////////////////////////////////Document open url////////////////////
  GetDocumentBase64(data){
    let params = new URLSearchParams();
    params.append('Id', data.id);
    this.ClientService.getClientDocumentBase64(params).pipe(takeUntil(this.onDestroy$)).subscribe(
      (response) => {
        let output=JSON.parse(response);
        this.DocumentName = data.documentName;
        this.isPdf = output.fileExtension?.includes("pdf");
        var blob = this.b64toBlob(output.fileBase64, output.fileExtension);
        if(this.isPdf){
          this.DocumentUrl = window.URL.createObjectURL(blob);
        }else{
          this.DocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
        }
        console.log(this.isPdf, this.DocumentUrl);
        document.getElementById("openViewDocumentModel").click()
      }
    );

  }
 b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  onActionComplete(args) {
    this.ClientDocumentFilterBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ClientDocumentFilterBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ClientDocumentFilterBO.type = args.columnType;
    }
    
  }
  ///////////////////////////////////////////Get Document List/////////////////////////////////////////////
  loadClientDocuments() {
    this.DocumentListService.execute(this.ClientDocumentFilterBO);
    var tsa = this.DocumentList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
      },
      (err) => {
        console.error('Error occurred:', err);
      }
    );
  }
  validateContentType(data){
    if(data.fileExtension?.includes("image") || data.fileExtension?.includes("pdf")){
      return true;
    }else{
      return false;
    }
  }

  ///////////////////////////////// FILTER FUNCTION ////////////////////////////
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ClientDocumentFilterBO.orderColumn = state.sorted[0].name;
        this.ClientDocumentFilterBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ClientDocumentFilterBO.field = state.action.currentFilterObject.field;
      this.ClientDocumentFilterBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ClientDocumentFilterBO.operator = state.action.currentFilterObject.operator;
      this.ClientDocumentFilterBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ClientDocumentFilterBO.field = "documentName";
        this.ClientDocumentFilterBO.matchCase = false;
        this.ClientDocumentFilterBO.operator = "startswith";
        this.ClientDocumentFilterBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Vendor.Pagesize != state.take) {
          this.arraycol[0].vendor.Pagesize = state.take
        }
      }
    }
    this.loadClientDocuments();
  }
  ///////////////////////////////////////Refersh Grid////////////////////////////////////////
  Refresh() {
    this.ClientDocumentFilterBO = new GetClientDocumentBO();
    this.ClientDocumentFilterBO.clientID = this.global.clientId;
    this.loadClientDocuments();
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}